import React, { useEffect, useState, Fragment } from 'react';
import { TableContent } from '../../../Common/Table/tableContent';
import $ from 'jquery';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import services from '../../services';
import { CommonEncryptParam } from '../../../../../utils/CommonParams';
import { useHistory } from 'react-router';

const screenCode = 'PURCHASEORDER';

export function OrderCompletionListing(props) {

    let history = useHistory();
    const { searchData, permission } = props;
    const contentRowNames = ["orderNumber", "dueDate", "invoiceDate", "buyerName"]
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false
    });
    const [data, setData] = useState([]);
    const [isAuthorized, setIsAuthorized] = useState(true);

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, []);

    useEffect(() => {
        trackPromise(
            getAllOrders()
        )
    }, [searchData.operationEntityID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWORDERCOMPLETION');

        if (isAuthorized === undefined) {
            setIsAuthorized(false);
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDORDERCOMPLETION');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
        });
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable({
            "order": []
        });
    }

    function handleClick(purchaseAdvice) {
        history.push({
            pathname: 'purchaseAdvice/orderCompletion/' + CommonEncryptParam(purchaseAdvice.orderID.toString()),
            data: purchaseAdvice,
            edit: true
        })
    }

    async function getAllOrders() {
        var result = await services.GetOrdersForCompletion(searchData.operationEntityID);
        destroyDataTable();
        setData(result);
        createDataTable();
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            {
                isAuthorized ?
                    <div className="row">
                        <div className="col-md-12">
                            <div className="table-responsive row-top-gap">
                                <table id="example" className="display dataTable no-footer">
                                    <thead>
                                        <tr>
                                            <th>Order Number</th>
                                            <th>Due Date</th>
                                            <th>Invoice Date</th>
                                            <th>Buyer</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <TableContent
                                            data={data}
                                            hasEdit={permissionList.isAddEditEnabled}
                                            contentRowNames={contentRowNames}
                                            handleClick={handleClick}
                                        />
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                : <p>You are unauthorized to access this page!</p>
            }
        </Fragment>
    )
}